export default function Hero() {
  const scrollTo = (id: string) => {
    const el = document.getElementById(id);
    if (el) el.scrollIntoView({ behavior: 'smooth' });
  };

  return (
    <section className="relative min-h-screen flex items-center justify-center overflow-hidden">
      <div className="absolute inset-0">
        <img
          src="https://public.readdy.ai/ai/img_res/cfabae79d5a5fa8f46766f7bfd63756f.jpg"
          alt="hero background"
          className="w-full h-full object-cover object-top"
        />
        <div className="absolute inset-0 bg-gradient-to-r from-black/70 via-black/50 to-black/30"></div>
      </div>
      <div className="relative z-10 w-full max-w-6xl mx-auto px-6 pt-20">
        <div className="max-w-2xl">
          <div className="inline-flex items-center gap-2 bg-red-500/20 border border-red-400/40 text-red-300 text-xs font-semibold px-4 py-1.5 rounded-full mb-6 tracking-wider">
            <i className="ri-qr-code-line text-sm"></i>
            NEW SERVICE
          </div>
          <h1 className="text-5xl font-black text-white leading-tight mb-6">
            店舗QRコードで<br />
            <span className="text-red-400">アフィリエイト</span>を<br />
            もっとかんたんに
          </h1>
          <p className="text-gray-300 text-lg leading-relaxed mb-8">
            お店にQRコードを置くだけ。来店客がスキャンするたびに<br />
            自動で成果が計測・報酬が発生する次世代アフィリエイト。
          </p>
          <div className="flex flex-wrap gap-4">
            <button
              onClick={() => scrollTo('contact')}
              className="cursor-pointer whitespace-nowrap bg-red-500 hover:bg-red-600 text-white font-bold px-8 py-4 rounded-md text-base transition-all hover:scale-105"
            >
              無料で資料請求する
            </button>
            <button
              onClick={() => scrollTo('service')}
              className="cursor-pointer whitespace-nowrap bg-white/10 border border-white/30 hover:bg-white/20 text-white font-semibold px-8 py-4 rounded-md text-base transition-all backdrop-blur-sm"
            >
              サービスを見る
            </button>
          </div>
          <div className="flex items-center gap-8 mt-12">
            {[
              { num: '準備中', label: '導入店舗数' },
              { num: '98%', label: '継続率' },
              { num: '¥0', label: '初期費用' },
            ].map((stat) => (
              <div key={stat.label} className="text-center">
                <div className="text-3xl font-black text-white">{stat.num}</div>
                <div className="text-gray-400 text-xs mt-1">{stat.label}</div>
              </div>
            ))}
          </div>
        </div>
      </div>
      <div className="absolute bottom-8 left-1/2 -translate-x-1/2 animate-bounce">
        <div className="w-6 h-6 flex items-center justify-center">
          <i className="ri-arrow-down-line text-white text-xl"></i>
        </div>
      </div>
    </section>
  );
}
